var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowngrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6766 0.57083C13.8823 0.768273 13.889 1.09506 13.6915 1.30073L10.2225 4.91431C10.1251 5.01572 9.99064 5.07304 9.85007 5.07304C9.70951 5.07304 9.57502 5.01572 9.47767 4.91431L7.37219 2.7211L4.87712 5.32013L6.65476 7.02667L0.929688 8.68662L2.35467 2.89858L4.13232 4.60513L6.99979 1.61818C7.09713 1.51677 7.23162 1.45945 7.37219 1.45945C7.51275 1.45945 7.64724 1.51677 7.74459 1.61818L9.85007 3.81139L12.9467 0.585726C13.1442 0.380055 13.4709 0.373386 13.6766 0.57083Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowngrade);
export default __webpack_public_path__ + "static/media/downgrade.219768e57c506abc20c7c1f9884d8533.svg";
export { ForwardRef as ReactComponent };